import { useQuery } from "@tanstack/react-query";

import { getDataFromResponse } from "~/api/axiosUtils.ts";
import { indexDraftInvoices } from "~/modules/billing/api/draftInvoice/draftInvoiceApiDispatchers.ts";
import { INVOICES_BASE_QUERY_KEY } from "~/modules/billing/api/processedInvoice/processedInvoiceQueries.ts";

export const ALL_DRAFT_INVOICES_QUERY_KEY = [INVOICES_BASE_QUERY_KEY, "draft"];

export const useAllDraftInvoices = () => useQuery({
		queryKey: ALL_DRAFT_INVOICES_QUERY_KEY,
		queryFn: () => indexDraftInvoices().then(getDataFromResponse),
	},
);